import React from 'react'

import useAugmentedRouter from 'hooks/useAugmentedRouter'

// Style
import style from 'pages/FavoritesPage.module.scss'

// Icons
import HeartEmpty from 'assets/icons/icon-heartEmpty.svg'
import HeartFilled from 'assets/icons/icon-heartFilled.svg'

const NoFavorites: React.FC = () => {
  const router = useAugmentedRouter()

  return (
    <div className={`${style.noFavoritesWrapper} ${style.noFavorites}`}>
      <HeartEmpty
        className={`${style.favoritesPromptHeart} ${style.emptyHeartLg}`}
        title=""
      />
      <p className={style.favoritesPrompt}>
        Every time you
        <HeartFilled
          className={`${style.emptyHeartSm} test-btn`}
          title="Favorite"
        />
        a home, we’ll save it right here
      </p>
      <button
        className={`btn btn-noStyle ${style.searchHomes}`}
        onClick={() => router.push(`/vacation-rentals/search`)}
      >
        Search homes
      </button>
    </div>
  )
}
export default NoFavorites
